export default __webpack_public_path__ + "static/media/NCTuvalu.a5d7c4a0.png";